import React from 'react';

interface WarningProps {
  message: string | string[];
}

export const Warning: React.FC<WarningProps> = ({ message }) => {
  if (!message || (Array.isArray(message) && message.length === 0)) {
    return null;
  }

  const messages = Array.isArray(message) ? message : [message];

  return (
    <div className="warning">
      {messages.map((msg, index) => (
        <p key={index}>{msg}</p>
      ))}
    </div>
  );
};
